import styled from 'styled-components';

export const StyledSidebar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	min-width: 25rem;
	max-width: 25rem;
	height: 100%;
	overflow-y: auto;
`;

export const Dot = styled.div<{ color?: string }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ color }) => color};
`;

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow: hidden;
	padding: 0 1rem;
`;

export const StyledTableWrapper = styled.div`
	flex: 1;
	min-height: 0;
`;

export const StyledHeader = styled.div`
	margin-bottom: 1.5rem;
	margin-top: 0.5rem;
`;
